import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsBadgeNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8 3.404l2.25 1.298v2.597L8 8.597 5.75 7.299V4.702zm-1 2.02v1.153l1 .577 1-.577V5.424l-1-.577z" />
        <path d="M7.179.632a1.625 1.625 0 011.642 0l3.375 1.977c.498.291.804.825.804 1.402V7.99c0 .577-.306 1.11-.804 1.402l-.238.14v5.35c0 .89-1.013 1.4-1.728.871L8 14.101l-2.23 1.652c-.715.53-1.728.02-1.728-.87V9.53l-.238-.14A1.625 1.625 0 013 7.99V4.01c0-.577.306-1.11.804-1.402zm-1.97 9.582v4.503L8 12.65l2.792 2.068v-4.502l-1.97 1.154a1.625 1.625 0 01-1.643 0zm2.98-8.503a.375.375 0 00-.379 0L4.435 3.687a.375.375 0 00-.185.324V7.99c0 .133.07.256.185.323L7.81 10.29a.375.375 0 00.38 0l3.374-1.977a.375.375 0 00.186-.323V4.01a.375.375 0 00-.186-.324z" />
      </g>
    </svg>
  )
);
SvgAchievementsBadgeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsBadgeNormalXsmall;
